export const SEAT_STATUSES = {
    QUOTE: 0,
    CONFIRMED: 2,
    CANCELLED: 3,
    UNCONFIRMED: 4,
};
export const SEAT_LABELS = {
    [SEAT_STATUSES.QUOTE]: 'Quote',
    [SEAT_STATUSES.CONFIRMED]: 'Confirmed',
    [SEAT_STATUSES.CANCELLED]: 'Cancelled',
    [SEAT_STATUSES.UNCONFIRMED]: 'Unconfirmed',
};




// WEBPACK FOOTER //
// ./src/app/modules/trip/seat-statuses.js